/**
 * A route's Striping Plan intersections (spec 2026-10-14 Part A): stored on the RsaPath
 * as `stripingIntersections: [{id, lat, lng, name}]` in paths_json. Pure list
 * operations for the reducer; numbers and default names are derived elsewhere.
 */
export const STRIPING_MATCH_FT = 150; // Linear_report config.INTERSECTION_MATCH_FT
export const STRIPING_MERGE_FT = 50; // Linear_report config.INTERSECTION_MERGE_FT
export const MAX_STRIPING_POINTS = 500; // a run accepts at most 500 intersections
export const MAX_STRIPING_NAME = 120;

export const listOf = (path) =>
  Array.isArray(path?.stripingIntersections) ? path.stripingIntersections : [];

export const makePoint = ({ id, lat, lng, name = "" }) => ({
  id,
  lat: Number(lat),
  lng: Number(lng),
  name: String(name ?? "").slice(0, MAX_STRIPING_NAME),
});

export const addPointToList = (list, point) => [...list, point];
export const addPointsToList = (list, points) => [...list, ...(points || [])];
export const movePointInList = (list, id, lat, lng) =>
  list.map((p) => (p.id === id ? { ...p, lat: Number(lat), lng: Number(lng) } : p));
export const renamePointInList = (list, id, name) =>
  list.map((p) =>
    p.id === id ? { ...p, name: String(name ?? "").slice(0, MAX_STRIPING_NAME) } : p,
  );
export const deletePointFromList = (list, id) => list.filter((p) => p.id !== id);
